<div class="instructions-panel">
  <div class="panel-header">
    <div class="header-copy">
      <div class="header-title-row">
        <h1 class="header-title">Instructions</h1>
        <span class="unsaved-tag" *ngIf="isDirty">
          <svg-icon src="assets/icons/clock.svg" aria-hidden="true" />
          Unsaved changes
        </span>
      </div>
      <span class="header-subtitle">{{ subtitle }}</span>
    </div>
    <div class="header-actions" *ngIf="isEditable || isDirty">
      <button nz-button nzType="default" class="header-btn" [disabled]="!isDirty || isSaving" (click)="discard()">Discard</button>
      <button nz-button nzType="primary" class="header-btn" *ngIf="isEditable" [disabled]="isSaveBlocked" (click)="save()">Save instructions</button>
    </div>
  </div>

  <div class="panel-tabs">
    <gains-tabset [styleType]="'Inline'" [selectedIndex]="activeTabIndex" (selectedIndexChange)="onTabIndexChange($event)">
      <gains-tab title="Project instructions"></gains-tab>
      <gains-tab title="Change history" [count]="versions.length"></gains-tab>
    </gains-tabset>
    <span class="tabs-hint">
      <svg-icon src="assets/icons/circle-info.svg" aria-hidden="true" />
      Read by DEO at the start of every chat
    </span>
  </div>

  <div class="panel-body app-scrollbar">
    <deo-panel-state
      *ngIf="loadError && !isLoading"
      mode="error"
      title="Instructions could not be loaded"
      [message]="loadError"
      layout="block"
      (retry$)="retryLoad()"
    ></deo-panel-state>

    <ng-container *ngIf="!loadError">
      <div class="editor" *ngIf="showEditor">
        <div class="editor-meta">
          <span class="editor-label">Instructions</span>
          <div class="meter">
            <div class="meter-track"><div class="meter-fill" [class.over-limit]="isOverLimit" [style.width.%]="meterPercentage"></div></div>
            <span class="meter-label" [class.over-limit]="isOverLimit">{{ formatCount(characterCount) }} / {{ formatCount(characterLimit) }}</span>
          </div>
        </div>

        <div class="editor-box-fill">
          <textarea
            class="editor-box app-scrollbar"
            spellcheck="false"
            aria-label="Project instructions"
            placeholder="Think step by step and show reasoning for complex problems. Use specific examples."
            [ngModel]="text"
            (ngModelChange)="onTextChange($event)"
            [readonly]="!canChangeText"
          ></textarea>
        </div>

        <div class="editor-footer">
          <span>{{ lastSavedLabel }}</span>
          <span class="footer-separator">&middot;</span>
          <span>Anyone with edit access to this project can change them</span>
          <span class="footer-separator">&middot;</span>
          <button type="button" class="footer-link" (click)="changeActiveTab('history')">Change history</button>
        </div>

        <div class="over-limit-banner" *ngIf="isOverLimit" role="alert">
          <svg-icon src="assets/icons/triangle-with-exclamation-mark.svg" aria-hidden="true" />
          <div class="banner-copy">
            <span class="banner-title">Instructions are {{ formatCount(charactersOverLimit) }} characters over the limit</span>
            <span class="banner-body">
              DEO reads only the first {{ formatCount(characterLimit) }} characters. Trim the rules, or keep the detail in a source file and reference it instead.
            </span>
          </div>
        </div>
      </div>

      <div class="history" *ngIf="activeTab === 'history'">
        <div class="history-row" *ngFor="let version of versions; trackBy: trackByVersionTag">
          <span class="history-tag">{{ version.tag }}</span>
          <span class="history-who">{{ version.savedBy }}</span>
          <span class="history-when">{{ versionSavedLabel(version) }}</span>
          <button type="button" class="history-restore" *ngIf="isEditable" [disabled]="isSaving" (click)="restoreVersion(version)">Restore</button>
        </div>

        <deo-panel-state
          *ngIf="versions.length === 0"
          mode="empty"
          icon="assets/icons/history.svg"
          title="No saved versions yet"
          message="Every time these instructions are saved, the version before it is kept here."
          layout="block"
        ></deo-panel-state>
      </div>
    </ng-container>
  </div>
</div>
